import * as Sentry from '@sentry/vue'
import { sentryDataCollection } from '~~/sentry.data-collection'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const {public: {sentry}} = useRuntimeConfig()
  if (!sentry.dsn) {
    return
  }
  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    dataCollection: sentryDataCollection,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Configure this whole part as you need it!
    tracesSampleRate: 0.5, // Capture 100% of the transactions
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', sentry.app_url],
    replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.5, // Change in prod if necessary
  })
})
